import en from "./languages/en";
import de from "./languages/de";
export var locales = {
  en,
  de
};
//# sourceMappingURL=index.js.map